import React from 'react'
import styled from 'styled-components'
import { ManageTeamFirst } from '../../Components/Staff/ManageTeam/ManageTeamFirst'
import { colors } from '../../Shared/colors'

export const ManageTeamComponent = () => {
  return (
    <Main> 
        <ManageTeamFirst/>
    </Main>
  )
}


const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
padding-top: 2em;
flex-direction: column;
justify-content: center;
align-items: center;
`